"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var color_picker_1 = require("../../controls/color-picker");
wp.customize.controlConstructor['epsilon-color-picker'] = wp.customize.Control.extend({
    ready: function () {
        var control = this;
        new color_picker_1.EpsilonColorPicker(control);
        control.container.on('change', 'input.epsilon-color-picker', function (e) {
            control.setting.set(jQuery(e.target).val());
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/extenders/controls/color-picker.ts
// module id = 12
// module chunks = 0